import request from "@/utils/request";

export function getProgramList() {
  return request({
    url: "/api/program/programs/",
    method: "get",
  });
}
